<template>
  <div id="session" @error="errorHandler">
    <div v-if="publisher">
      <publisher :session="session" @error="errorHandler" :opts="options"></publisher>
    </div>
   
    <div id="subscribers" v-for="stream in streams" :key="stream.streamId">
      <subscriber
        @error="errorHandler"
        :stream="stream"
        :session="session"
        :opts="options"
      ></subscriber>
    </div>
  </div>
</template>

<script>
import OT from "@opentok/client";
import Publisher from "./Publisher.vue";
import Subscriber from "./Subscriber.vue";

const errorHandler = (err) => {
  alert(err.message);
};

export default {
  name: "session",
  components: { Publisher, Subscriber },
  props: {
    apiKey: {
      type: String,
      default: "",
    },
    sessionId: {
      type: String,
      default: "",
    },
    token: {
      type: String,
      default: "",
    },
    publisher: {
      type: Boolean,
      default: false,
    }
  },
  created() {
    this.session = OT.initSession(this.apiKey, this.sessionId);

    this.session.connect(this.token, (err) => {
      if (err) {
        errorHandler(err);
      }
    });

    this.session.on("streamCreated", (event) => {
      console.log('streamCreated : ' ,event.stream)
      this.options = {
        width: event.stream.videoDimensions.width, 
        height: event.stream.videoDimensions.height
      }
      this.streams.push(event.stream);
      this.$emit("streamCreated", event.stream)
    });
    this.session.on("streamDestroyed", (event) => {
      console.log('destroyed stream : ', event.stream)
      const idx = this.streams.indexOf(event.stream);
      if (idx > -1) {
        this.streams.splice(idx, 1);
      }
      this.$emit("streamDestroyed")
    });
  },
  data: () => ({
    streams: [],
    session: null,
    options:{width: 640, height: 480, insertMode: 'append'}
  }),
  methods: {
    errorHandler,
  },
};
</script>

<style>
.OT_subscriber {
  float: left;
}
.OT_publisher {
  float: left;
}
</style>
